// Anchor Status Language — nautical-themed brand copy
// From PR-19: replaces generic UI copy with Data Anchor terminology

export const STATUS = {
  // Fleet status
  ALL_CLEAR: 'Anchor Set',
  DEGRADING: 'Anchor Drifting',
  CRITICAL: 'Anchor Dragging',
  DISCONNECTED: 'Anchor Lost',
  SCANNING: 'Raising Anchor',
  SCAN_COMPLETE: 'Anchor Dropped',
  RESCAN: 'Verify Remediation',

  // Score language
  scoreLabel: (score: number) => `Anchor holding at ${score}%`,
  gapLabel: (count: number) => `${count} cell${count !== 1 ? 's' : ''} to fill`,

  // Report naming
  REPORT: 'Posture Report',
  FLEET_OVERVIEW: 'Fleet Posture',
  COMPLIANCE: 'Anchor Trust Score',
} as const;

export function getFleetStatus(score: number, errorCount: number, offlineCount: number): string {
  if (errorCount > 0 || score < 65) return STATUS.CRITICAL;
  if (offlineCount > 3 || score < 80) return STATUS.DEGRADING;
  return STATUS.ALL_CLEAR;
}

export function getAgentStatus(status: string): string {
  switch (status.toUpperCase()) {
    case 'ONLINE': return STATUS.ALL_CLEAR;
    case 'OFFLINE': return STATUS.DISCONNECTED;
    case 'ERROR': return STATUS.CRITICAL;
    case 'MAINTENANCE': return STATUS.SCANNING;
    default: return status;
  }
}
